import { render } from "./UserInputLabel.vue?vue&type=template&id=37a72a0e&ts=true"
import script from "./UserInputLabel.vue?vue&type=script&lang=ts"
export * from "./UserInputLabel.vue?vue&type=script&lang=ts"

import "./UserInputLabel.vue?vue&type=style&index=0&id=37a72a0e&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__